import { Component, Vue } from 'vue-property-decorator'
import { uniqueId } from 'lodash'

/**
 * Populating the `id` prop in the inherited component will for the bv-group
 *
 * @example
 *
 * created () {
 *  this.id = this.uniqueId('widget')
 * }
 */
@Component
export default class extends Vue {
  /**
   * Generates a unique ID appending the given `affix` to it.
   *
   * Wraps the lodash function uniqueId with the prefix argument `'__WID_'`.
   *
   * @param {string} [affix=''] The value to affix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * this.uniqueId('_input')
   * // => '__WID_42_input'
   *
   * this.uniqueId()
   * // => '__WID_43'
   */
  uniqueId = (affix: string = '') => uniqueId('__WID_') + affix
}
